import api from './api';

export interface FtthPoste {
  id: number;
  identificacao: string;
  escritorio_id: number;
  latitude: number | null;
  longitude: number | null;
  informacoes: string | null;
  color: string;
  icon: string | null;
  usuarioId_criou: number;
  createdAt: string;
  updatedAt: string;
  usuario_criou?: { id: number; nome: string; usuario: string };
  escritorio?: { id: number; identificacao: string; nome_fantasia: string };
}

export interface FtthPosteForMap {
  id: number;
  identificacao: string;
  latitude: number | null;
  longitude: number | null;
  color: string;
  icon: string | null;
  escritorio_id: number;
}

class FtthPosteService {
  async getPostes(params?: {
    page?: number;
    limit?: number;
    search?: string;
    escritorio_id?: number;
  }) {
    const response = await api.get('/ftth-postes', { params });
    return response.data;
  }

  async getPostesForMap(): Promise<FtthPosteForMap[]> {
    // O interceptor do api já retorna response.data, então "response" é o body (array ou objeto)
    const response = await api.get('/ftth-postes/map');
    if (Array.isArray(response)) return response;
    if (response?.data && Array.isArray(response.data)) return response.data;
    return [];
  }

  async getPoste(id: number) {
    const response = await api.get(`/ftth-postes/${id}`);
    return response.data?.data ?? response.data;
  }

  async create(data: {
    identificacao: string;
    escritorio_id: number;
    latitude?: number | null;
    longitude?: number | null;
    informacoes?: string | null;
    color?: string;
    icon?: string | null;
  }) {
    const response = await api.post('/ftth-postes', data);
    return response.data?.data ?? response.data;
  }

  async update(
    id: number,
    data: Partial<{
      identificacao: string;
      escritorio_id: number;
      latitude: number | null;
      longitude: number | null;
      informacoes: string | null;
      color: string;
      icon: string | null;
    }>
  ) {
    const response = await api.put(`/ftth-postes/${id}`, data);
    return response.data?.data ?? response.data;
  }

  async delete(id: number) {
    await api.delete(`/ftth-postes/${id}`);
  }
}

export const ftthPosteService = new FtthPosteService();
